import { render, staticRenderFns } from "./TextInputConfig.vue?vue&type=template&id=bd2bd116&scoped=true"
import script from "./TextInputConfig.vue?vue&type=script&lang=js"
export * from "./TextInputConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2bd116",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd2bd116')) {
      api.createRecord('bd2bd116', component.options)
    } else {
      api.reload('bd2bd116', component.options)
    }
    module.hot.accept("./TextInputConfig.vue?vue&type=template&id=bd2bd116&scoped=true", function () {
      api.rerender('bd2bd116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/config/TextInputConfig.vue"
export default component.exports